// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const SET_COPILOTO = '@customization/SET_COPILOTO';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

export const SET_PRIMARY_COLOR = 'SET_PRIMARY_COLOR';
export const SET_BG_COLOR = 'SET_BG_COLOR';
export const SET_TEXT_COLOR = 'SET_TEXT_COLOR';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_MODE = 'SET_MODE';
export const ACCOUNT_LOGOUT = '@account/LOGOUT';
export const SET_SECONDARY_COLOR = 'SET_SECONDARY_COLOR';
